import React, { useState } from "react";
import Header from "../Course/Header";
import Banner from "../Course/Banner";
import Footer from "../Footer";
import { Button } from "@material-ui/core";
import "bootstrap/dist/css/bootstrap.css";

import { Viewer } from "@react-pdf-viewer/core";
import { defaultLayoutPlugin } from "@react-pdf-viewer/default-layout";
import "@react-pdf-viewer/core/lib/styles/index.css";
import "@react-pdf-viewer/default-layout/lib/styles/index.css";
import { Worker } from "@react-pdf-viewer/core";
import "./CVpdf.css";

function CVpdf() {
  // Create new plugin instance
  const defaultLayoutPluginInstance = defaultLayoutPlugin();
  // for onchange event
  const [pdfFile, setPdfFile] = useState(null);
  const [pdfFileError, setPdfFileError] = useState("");

  //for submit event
  const [viewPdf, setViewPdf] = useState(null);

  // onchange event
  const fileType = ["application/pdf"];

  const heandlePdfFileChange = (e) => {
    let selectedFile = e.target.files[0];
    if (selectedFile) {
      if (selectedFile && fileType.includes(selectedFile.type)) {
        let reader = new FileReader();
        reader.readAsDataURL(selectedFile);
        reader.onloadend = (e) => {
          setPdfFile(e.target.result);
          setPdfFileError("");
        };
      } else {
        setPdfFile(null);
        setPdfFileError("please select valid pdf file");
      }
    } else {
      console.log("select your file.");
    }
  };

  // form submit
  const heandlePdfFileSubmit = (e) => {
    e.preventDefault();
    if (pdfFile !== null) {
      setViewPdf(pdfFile);
    } else {
      setViewPdf(null);
    }
  };

  return (
    <div className="cv">
      <Header />
      <hr
        style={{
          width: "100%",
          marginTop: "-30px",
          marginBottom: "30px",
          height: "2px",
        }}
      />
      <Banner />
      <div className="container">
        <form className="form-group" onSubmit={heandlePdfFileSubmit}>
          <input
            type="file"
            // className="form-group"
            required
            onChange={heandlePdfFileChange}
          />
          {pdfFileError && (
            <div style={{ color: "red", fontSize: "20px" }}>{pdfFileError}</div>
          )}
          <Button type="submit" variant="contained" color="secondary">
            UPLOAD
          </Button>
        </form>
        <h4>View My CV Here</h4>
        <div className="cvview-space">
          {viewPdf && (
            <>
              <Worker workerUrl="https://unpkg.com/pdfjs-dist@2.6.347/build/pdf.worker.min.js">
                <Viewer
                  fileUrl={viewPdf}
                  plugins={[defaultLayoutPluginInstance]}
                />
              </Worker>
            </>
          )}
          {!viewPdf && <div className="viewpdf">No pdf file selected </div>}
        </div>
      </div>
      <Footer />
    </div>
  );
}

export default CVpdf;
